import React from 'react'
import type { PayloadServerReactComponent, SanitizedConfig } from 'payload'

export const LogoutButton: PayloadServerReactComponent<
    SanitizedConfig['admin']['components']['logout']['Button']
> = () => {
    return <div></div>
}
